import { isEmpty, isNil, sortBy } from 'lodash';
import vacation from '../../static/js/vacation';

export default {
  data: function () {
    return {
      ...vacation,
    };
  },

  computed: {
    today: function () {
      const now = this.$moment().tz('Europe/Vienna');
      return now.format('YYYY-MM-DD');
    },
    isVacation: function () {
      return this.vacations.some(it => this.today >= it[0] && this.today <= it[1]);
    },
    vacationEndDate: function () {
      if (this.isVacation) return this.vacations.filter(it => this.today >= it[0] && this.today <= it[1])[0][1];
      else return null;
    },
  },


  created() {
    this.addFixedPeriods();
  },

  methods: {
    addFixedPeriods() {
      // compute Christmas holidays
      const currentYear = new Date().getFullYear();
      for (let i = 0; i < 3; i++) {
        const year = currentYear + i;
        let christmasHolidayStart = this.$moment(`${year}-12-23`, 'YYYY-MM-DD');
        let christmasHolidayEnd = this.$moment(`${year + 1}-01-08`, 'YYYY-MM-DD');

        if (christmasHolidayStart.isoWeekday() === 2) { // tuesday
          christmasHolidayStart = christmasHolidayStart.add(-3, 'days');
        }
        if (christmasHolidayEnd.isoWeekday() === 4) { // thursday
          christmasHolidayEnd = christmasHolidayEnd.add(3, 'days');
        }

        this.vacations.push([christmasHolidayStart.format('YYYY-MM-DD'), christmasHolidayEnd.format('YYYY-MM-DD'), 'Weihnachten']);
      }

      const $vm = this;

      function addDay(day, desc = null) {
        const containedIn = $vm.vacations.find(itVacation => day >= itVacation[0] && day <= itVacation[1]);
        if (isNil(containedIn)) {
          if (!isEmpty(desc)) $vm.vacations.push(([day, day, desc]));
          else $vm.vacations.push(([day, day]));
        }
      }

      function addDayLongWeekend(day) {
        const dayString = day.format('YYYY-MM-DD');
        switch (day.isoWeekday()) {
          case 1: // monday
          case 2: // tuesday
            $vm.vacations.push([day.add(1 - day.isoWeekday(), 'days').format('YYYY-MM-DD'), dayString]);
            break;
          case 3:
          case 4:
          case 5:
            $vm.vacations.push([dayString, day.add(5 - day.isoWeekday(), 'days').format('YYYY-MM-DD')]);
            break;
          default: // weekend
            break;
        }
      }

      // Birthdays
      addDayLongWeekend(this.$moment(`${currentYear}-08-19`));
      addDayLongWeekend(this.$moment(`${currentYear}-01-16`));
      addDayLongWeekend(this.$moment(`${currentYear}-07-03`));
      addDayLongWeekend(this.$moment(`${currentYear}-10-29`));

      this.vacations = sortBy(this.vacations, it => it[0]);

      const tmpVacations = [];
      let lastRecord = null;

      this.vacations.forEach((it) => {
        if (isNil(lastRecord)) {
          tmpVacations.push(it);
          lastRecord = it;
        } else if (it[0] <= lastRecord[1] && it[1] > lastRecord[1]) {
          lastRecord[1] = it[1];
        } else if (it[0] > lastRecord[1]) {
          tmpVacations.push(it);
          lastRecord = it;
        }
      });

      this.vacations = tmpVacations;

      // compute Fenstertage
      this.holidays.forEach((it) => {
        const date = this.$moment(it, 'YYYY-MM-DD');
        let fenstertag = null;
        if (date.isoWeekday() === 2) fenstertag = date.add(-1, 'days');
        if (date.isoWeekday() === 4) fenstertag = date.add(1, 'days');
        if (!isNil(fenstertag)) {
          const tmp = fenstertag.format('YYYY-MM-DD');
          addDay(tmp, 'Fenstertag');
        }
      });

      this.vacations = sortBy(this.vacations, it => it[0]);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/VacationMixin.js